;
define("facets_faceted_navigation_item_color.tpl", function(){});

